module.exports = __webpack_public_path__ + "media/prize.c9a9.mp3";